<template>
  <section class="home">
    <za-banner></za-banner>
    <article class="article">
      <h1 class="article-title">产品特点</h1>
      <p class="sub-title">能快速高效地接收、发送消息，提高工作效率的同时让沟通更方便。</p>
      <section class="article-inner" @click="toLogin">
        <template v-for="(item, index) in reportsList">
          <div class="article-item" :key="index">
              <img class="article-item-img" :src="item.img" alt="">
              <div class="item-right">
                <h2 class="article-item-title">{{item.title}}</h2>
                <p class="article-item-desc">{{item.desc}}</p>
              </div>

          </div>
        </template>
      </section>
    </article>
  </section>
</template>

<script>
import zaBanner  from '@/components/Banner.vue'
export default {
  components: {
    zaBanner
  },
  data () {
    return {
      reportsList: [{
        img: require('../assets/market.png'),
        title: '营销人员使用',
        desc: '营销人员需要同时管理多个社群，经常要回复很多信息、解答疑惑。'
      }, {
        img: require('../assets/business.png'),
        title: '运营人员使用',
        desc: '管理多个运营账号，维护用户和粉丝社群，需要来回切换用户回复用户、粉丝信息。'
      }, {
        img: require('../assets/sail.png'),
        title: '销售人员使用',
        desc: '维护客户，以及跟进客户、与客户进行及时沟通。'
      }]
    }
  },
  methods: {
    toLogin() {
      this.$router.push('./login')
    }
  }
}
</script>
<style scoped>
.article {
  width: 1200px;
  margin: 0 auto;
  padding: 50px 0 130px; 
}
.article-title {
  font-size: 36px;
  text-align: center;
}
.article-inner {
  padding: 65px 88px;
  font-size: 18px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.article-item:nth-child(4n) {
  margin-right: 0;
}
.article-item-cover {
  width: 202px;
  height: 160px;
  padding: 12px;
  color: rgba(255, 255, 255, .7);
  background-image: url('../assets/cardBg.png');
}
.article-item-title {
  width: 180px;
  margin: 20px auto;
  text-align: center;
  color: #000;
}
.article-item-desc {
  font-size: 14px;
  line-height: 30px;
  color: #333;
}
.more-link {
  text-align: center;
}
.more-link a {
  font-size: 18px;
  height: 27px;
  line-height: 27px;
  display: inline-block;
  color: #016091;
  padding-bottom: 1px;
}
.more-link a:hover {
  border-bottom: 1px solid #016091;
}
.more-link a span {
  font-weight: 700;
}
.sub-title {
  margin: 50px;
  text-align: center;
}
.item-right {
  display: inline-block;
  width: 202px;
  margin-bottom: 30px;
  margin-left: 80px;
}
</style>